import React from "react";

const Loading = () => {
  return (
    <div className="flex justify-center items-center text-yellow-200">
      <div className="w-16 h-16 border-4 border-dashed rounded-full animate-spin dark:border-emerald-400"></div>
    </div>
  );
};

export default Loading;
